const SCOPE = "global"
const ACTIONS = {
  initApp: "initApp"
}
const MUTATIONS = {
  setIsLoggedIn: "setIsLoggedIn",
  setConfirmAttr: "setConfirmAttr"
}
const GETTERS = {
  isLoggedIn: `${SCOPE}/isLoggedIn`,
  getConfirmAttr: `${SCOPE}/getConfirmAttr`
}
const DISPATCH = {
  initApp: `${SCOPE}/${ACTIONS.initApp}`
}
const COMMIT = {
  setIsLoggedIn: `${SCOPE}/${MUTATIONS.setIsLoggedIn}`,
  setConfirmAttr: `${SCOPE}/${MUTATIONS.setConfirmAttr}`
}

export default { ACTIONS, MUTATIONS, GETTERS, DISPATCH, COMMIT };

export const DSR_ACCESS_TOKEN = "DSR_ACCESS_TOKEN"
